(() => {
'use strict';
const INSTALL_KEY = '__G21_FORCE_VARIANT_AVAILABILITY__';
if (window[INSTALL_KEY]) return;
window[INSTALL_KEY] = true;
const PICKER_SELECTOR = 'variant-picker[data-g21-force-availability="true"]';
const ADD_BUTTON_SELECTOR = [
'product-form-component add-to-cart-component button[ref="addToCartButton"]',
'product-form-component button[name="add"]',
'sticky-add-to-cart button[ref="addToCartButton"]',
'product-card add-to-cart-component button[ref="addToCartButton"]',
'product-card .add-to-cart__button button'
].join(',');
const queue = new Set();
let frame = 0;
const cssEscape = (value) => {
if (window.CSS?.escape) return window.CSS.escape(String(value));
return String(value).replace(/[^a-zA-Z0-9_-]/g, '\\$&');
};
const schedule = (root = document) => {
queue.add(root instanceof Node ? root : document);
if (frame) return;
frame = requestAnimationFrame(() => {
frame = 0;
const roots = Array.from(queue);
queue.clear();
roots.forEach(forceAll);
});
};
const nearestSection = (element) =>
element?.closest?.('.shopify-section, dialog, product-card') || document;
const pickerForProduct = (element, productId = '') => {
const scope = nearestSection(element);
if (productId) {
const exact = scope.querySelector?.(
`${PICKER_SELECTOR}[data-product-id="${cssEscape(productId)}"]`
);
if (exact) return exact;
}
return scope.querySelector?.(PICKER_SELECTOR) || document.querySelector(PICKER_SELECTOR);
};
const selectedVariantId = (picker) => {
if (!(picker instanceof HTMLElement)) return '';
const selectedControl = picker.querySelector(
'select option:checked[data-variant-id], select option[selected][data-variant-id], input:checked[data-variant-id]'
);
const selectedId = selectedControl?.getAttribute('data-variant-id') || '';
if (/^\d+$/.test(selectedId)) return selectedId;
const fallback = picker.dataset.g21FallbackVariantId || '';
return /^\d+$/.test(fallback) ? fallback : '';
};
const forceOption = (control) => {
if (!(control instanceof HTMLElement)) return;
control.removeAttribute('disabled');
control.removeAttribute('aria-disabled');
if (control.dataset.optionAvailable !== 'true') control.dataset.optionAvailable = 'true';
control.classList.remove('disabled', 'is-disabled', 'unavailable', 'is-unavailable', 'sold-out', 'is-sold-out');
if (control instanceof HTMLOptionElement) {
const cleanLabel = control.dataset.g21OptionLabel;
if (cleanLabel && control.textContent !== cleanLabel) control.textContent = cleanLabel;
control.disabled = false;
}
if (control instanceof HTMLInputElement || control instanceof HTMLSelectElement) {
control.disabled = false;
}
};
const forcePicker = (picker) => {
if (!(picker instanceof HTMLElement)) return;
picker.dataset.g21AvailabilityForced = 'true';
picker.querySelectorAll('[data-option-available], option, input, select').forEach(forceOption);
picker.querySelectorAll('.variant-option__strikethrough').forEach((element) => element.remove());
};
const forceButtonText = (button, text) => {
if (!(button instanceof HTMLButtonElement) || !text) return;
const target = button.querySelector('.add-to-cart-text__content > span > span');
if (target && target.textContent?.trim() !== text) target.textContent = text;
};
const forceButton = (button) => {
if (!(button instanceof HTMLButtonElement)) return;
const productForm = button.closest('product-form-component');
const productId = productForm?.dataset.productId || button.closest('product-card')?.dataset.productId || '';
const picker = pickerForProduct(button, productId);
const addText = picker?.dataset.g21AddToCartText || '';
button.disabled = false;
button.removeAttribute('disabled');
button.removeAttribute('aria-disabled');
button.dataset.g21AvailabilityForced = 'true';
forceButtonText(button, addText);
const component = button.closest('add-to-cart-component');
if (component && component.dataset.g21DisableOverride !== 'true') {
component.dataset.g21DisableOverride = 'true';
component.disable = function () {
const target = this.querySelector('button[ref="addToCartButton"], button[name="add"]');
if (target instanceof HTMLButtonElement) {
target.disabled = false;
target.removeAttribute('disabled');
target.removeAttribute('aria-disabled');
}
};
}
};
const forceProductForm = (productForm) => {
if (!(productForm instanceof HTMLElement)) return;
const picker = pickerForProduct(productForm, productForm.dataset.productId || '');
const fallbackVariantId = selectedVariantId(picker);
const variantInput = productForm.querySelector('input[name="id"], input[ref="variantId"]');
if (variantInput instanceof HTMLInputElement) {
const currentValue = String(variantInput.value || '').trim();
if (!/^\d+$/.test(currentValue) && fallbackVariantId) {
variantInput.value = fallbackVariantId;
variantInput.setAttribute('value', fallbackVariantId);
}
}
productForm.querySelectorAll('add-to-cart-component').forEach((component) => {
const button = component.querySelector('button[ref="addToCartButton"], button[name="add"]');
if (button instanceof HTMLButtonElement) forceButton(button);
});
productForm
.querySelectorAll('[ref="acceleratedCheckoutButtonContainer"], shopify-accelerated-checkout')
.forEach((element) => element.removeAttribute('hidden'));
};
const forceSticky = (sticky) => {
if (!(sticky instanceof HTMLElement)) return;
const picker = pickerForProduct(sticky, sticky.dataset.productId || '');
const fallbackVariantId = selectedVariantId(picker);
sticky.dataset.variantAvailable = 'true';
if (!sticky.dataset.currentVariantId && fallbackVariantId) {
sticky.dataset.currentVariantId = fallbackVariantId;
}
sticky.querySelectorAll('button[ref="addToCartButton"]').forEach(forceButton);
};
function forceAll(root = document) {
const scope = root instanceof Element || root instanceof Document || root instanceof DocumentFragment ? root : document;
if (scope instanceof Element) {
if (scope.matches(PICKER_SELECTOR)) forcePicker(scope);
if (scope.matches('product-form-component')) forceProductForm(scope);
if (scope.matches('sticky-add-to-cart')) forceSticky(scope);
if (scope.matches(ADD_BUTTON_SELECTOR)) forceButton(scope);
}
scope.querySelectorAll?.(PICKER_SELECTOR).forEach(forcePicker);
scope.querySelectorAll?.('product-form-component').forEach(forceProductForm);
scope.querySelectorAll?.('sticky-add-to-cart').forEach(forceSticky);
scope.querySelectorAll?.(ADD_BUTTON_SELECTOR).forEach(forceButton);
}
const sustainAfterInteraction = (root) => {
[0, 40, 120, 300, 700, 1400].forEach((delay) => {
setTimeout(() => forceAll(root || document), delay);
});
};
document.addEventListener('change', (event) => {
const picker = event.target instanceof Element ? event.target.closest(PICKER_SELECTOR) : null;
if (picker) sustainAfterInteraction(nearestSection(picker));
}, true);
document.addEventListener('submit', (event) => {
const form = event.target;
const productForm = form instanceof Element ? form.closest('product-form-component') : null;
if (productForm) forceProductForm(productForm);
}, true);
document.addEventListener('click', (event) => {
const button = event.target instanceof Element ? event.target.closest(ADD_BUTTON_SELECTOR) : null;
if (button instanceof HTMLButtonElement) forceButton(button);
}, true);
['shopify:section:load', 'shopify:section:select', 'shopify:block:select'].forEach((eventName) => {
document.addEventListener(eventName, (event) => sustainAfterInteraction(event.target));
});
new MutationObserver((records) => {
records.forEach((record) => {
if (record.type === 'attributes') schedule(record.target);
record.addedNodes.forEach((node) => {
if (node instanceof Element || node instanceof DocumentFragment) schedule(node);
});
});
}).observe(document.documentElement, {
childList: true,
subtree: true,
attributes: true,
attributeFilter: ['disabled', 'aria-disabled', 'hidden', 'data-option-available', 'value']
});
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', () => forceAll(document), { once: true });
} else {
forceAll(document);
}
window.setInterval(() => forceAll(document), 800);
window.G21ForceVariantAvailability = Object.freeze({
installed: true,
forceAll,
selectedVariantId
});
})();
